interface RoomCountCellProps {
  count: number;
}

export const RoomCountCell = ({ count }: RoomCountCellProps) => <span>{count}</span>;
